<template>
  <section class="maintenancePage">
    <div class="maintenance loading" v-if="loading"></div>
    <div class="maintenance" :style="{'background-color': d.maintenanceBgColor,
      'background-image': `url(${d.maintenanceBg[lang]
      ? d.maintenanceBg[lang].imageLg : ''})`}" v-else>
      <div class="maintenanceOverlay" v-if="d.maintenanceBg[lang]"></div>
      <div class="maintenanceCnt">
        <div class="cnt">
          <div class="maintenanceContent" :style="{color: d.maintenanceTextColor}">
            <h2>{{d.maintenanceTitle[lang]}}</h2>
            <p>{{d.maintenanceDesc[lang]}}</p>
            <div class="langSelector">
              <a href="/en-us/maintenance" class="langItem"
                :style="{color: d.maintenanceTextColor}">English (US)</a>
              <div class="divider"
                :style="{'background-color': d.maintenanceTextColor}"></div>
              <a href="/id-id/maintenance" class="langItem"
                :style="{color: d.maintenanceTextColor}">Bahasa Indonesia</a>
            </div>
            <div class="btnCnt" v-if="d.maintenanceBtn">
              <a :href="d.maintenanceBtnUrl"
                class="btn primary">{{d.maintenanceBtnLabel[lang]}}</a>
            </div>
            <div class="socmedCnt" v-if="d.maintenanceSocmed && socmed">
              <h3>{{socmed.footerSocmedLabel[lang]}}</h3>
              <p>{{socmed.footerSocmedDesc[lang]}}</p>
              <div class="media-sosial-icon-container mt-2">
                <div class="media-sosial-icon" v-for="(item, i) in socmed.socmed" :key="`sc${i}`">
                  <a :href="item.url" target="_blank" :title="item.name">
                    <img :src="item.media.imageSm">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'maintenance',
  components: {},
  data() {
    return {
      loading: true,
      d: null,
      socmed: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  computed: {},
  methods: {},
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      let langCode = window.navigator.userLanguage || window.navigator.language;
      langCode = (langCode === 'id-ID') ? 'id' : 'en';
      const countryCode = (langCode === 'id') ? 'id' : 'us';
      window.location.href = `/${langCode}-${countryCode}`;
    }

    /**
     * Get maintenance detail
     *
     */
    this.$http.get(this.$config.uri('config/section/maintenance')).then((r) => {
      this.loading = false;
      this.d = r.data.status === 200 ? r.data.data : null;

      /**
       * Get social media data
       *
       */
      if (this.d.maintenanceSocmed) {
        this.$http.get(this.$config.uri('config/section/socmed')).then((r2) => {
          this.socmed = r2.data.status === 200 ? r2.data.data : null;
        });
      }
    });
  },
};
</script>

<style scoped lang="scss">
.maintenancePage{
  .maintenance{
    position: absolute;
    left: 0; right: 0; bottom: 0; top: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    &.loading{
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 46px auto;
    }
    .maintenanceOverlay{
      background-color: #000;
      position: absolute;
      left: 0; right: 0; bottom: 0; top: 0;
      opacity: .14;
      display: none;
    }
    .maintenanceCnt{
      width: 100%;
      position: relative;
      z-index: 7;
      .maintenanceContent{
        max-width: 780px;
        margin: 0 auto;
        text-align: center;
        color: #444;
        h2{
          font-size: 46px;
          margin: 0;
          @media (max-width: 1480px) {
            font-size: 36px;
          }
          @media (max-width: 640px) {
            font-size: 32px;
            line-height: 1.3;
            margin: 0 0 6px;
          }
        }
        p{
          margin: 0;
          font-size: 20px;
          line-height: 1.4;
          @media (max-width: 1480px) {
            font-size: 18px;
          }
          @media (max-width: 640px) {
            font-size: 15px;
          }
        }
      }
      .langSelector{
        padding: 30px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .langItem{
          display: block;
          font-size: 17px;
          font-weight: 500;
          padding: 4px 10px;
          color: #444;
          @media (max-width: 1480px) {
            font-size: 15px;
          }
        }
        .divider{
          width: 2px; height: 20px;
          background-color: #444;
          margin: 0 4px;
          @media (max-width: 1480px) {
            height: 18px;
          }
        }
      }
      .btnCnt{
        padding: 30px 0 0;
      }
      .socmedCnt{
        padding: 30px 0 0;
        h3{
          margin: 0;
          font-size: 18px;
          @media (max-width: 1480px) {
            font-size: 17px;
          }
        }
        p{
          font-size: 16px;
          margin: 0;
          @media (max-width: 1480px) {
            font-size: 15px;
          }
        }
        .media-sosial-icon-container{
          display: flex;
          justify-content: center;
          padding: 10px 0 0;
          .media-sosial-icon{
            font-size: 30px;
            margin: 0 5px;
            border-radius: 50%;
            overflow: hidden;
            img{
              height: 40px;
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
